import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import generateSearchLinkFilter from '~/utilities/generateSearchFilterLink';

export type Filters = {
  makes: Array<{
    name: string;
    models: Array<{
      name: string;
    }>;
  }>;
};

export type CvnaId = {
  filters: Filters & {
    isFreeDelivery?: boolean;
  };
};

export default function useMakeModelSearchLink(withFreeDelivery = false) {
  const { make = '', model = '' } = useGetVehicleDetails();
  const filtersObject: CvnaId = {
    filters: {
      makes: [{ name: make, models: [{ name: model }] }]
    }
  };

  if (withFreeDelivery) {
    filtersObject.filters.isFreeDelivery = true;
  }

  return generateSearchLinkFilter(filtersObject);
}
